(function ( $ ) {

    $('body').on('app.init', function(ev) {
        $(ev.container).find('[search-result]').on('click', function(jsEvent) {
            var $result = $(this);
            window.CalendarTooltip.render($result.data('event'), $result, jsEvent);
        });
    });

}) (require('jquery'));
